import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import {isMobile} from 'react-device-detect';
const Index =lazy(() => isMobile?import("./pages/IndexMobile"):import("./pages/Index"));
const Themes =lazy(() => isMobile?import("./Components/Themes"):import("./pages/Index"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const StakeholderAck = lazy(() => import("./pages/StakeholderAck"));
const Sitemap = lazy(() => import("./pages/Sitemap"));
const PageNotFound = lazy(() => import("./pages/404"));
const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));
const Search = lazy(() => import("./pages/Search"));
const Health = lazy(() => import("./Components/ThemePage"));
const WomenEmpowerment = lazy(() => import("./Components/WomenEmpowerment"));
const Environment = lazy(() => import("./Components/Environment"));
const CultureAndHeritage = lazy(() => import("./Components/CultureAndHeritage"));
const Infrastructure = lazy(() => import("./Components/Infrastructure"));
const Education = lazy(() => import("./Components/Education"));
const Energy = lazy(() => import("./Components/Energy"));
const YouthEmpowerment = lazy(() => import("./Components/YouthEmpowerment"));
const Population = lazy(() => import("./Components/Population"));
const InfoPage = lazy(() => import("./pages/InfoPage"));
const FurtureHorizon= lazy(() => import("./Components/FutureHorizon"));
const RIContext= lazy(() => import("./Components/RIContext"));
const MapsAndGazetteer=lazy(() => import("./Components/MapsAndGazetteer"));
const Economy = lazy(() => import("./Components/Economy"));
// const Smartcities = lazy(() => import("./Components/Smartcities"));
export default function App() {
  
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="Index" element={<Index />} />
        <Route path="ContactUs" element={<ContactUs />} />
        <Route path="Disclaimer" element={<Disclaimer />} />
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="StakeholderAck" element={<StakeholderAck />} />
        <Route path="Sitemap" element={<Sitemap />} />
        <Route path="404" element={<PageNotFound />} />
        <Route path="UnderConstruction" element={<UnderConstruction />} />
        <Route path="Search/:source" element={<Search />} />
        <Route path="Themes" element={<Themes />} />
        <Route path="Health/:source" element={<Health />} />
        <Route path="WomenEmpowerment/:source" element={<WomenEmpowerment />} />
        <Route path="Environment/:source" element={<Environment />} />
        <Route path="CultureAndHeritage/:source" element={<CultureAndHeritage />} />
        <Route path="Infrastructure/:source" element={<Infrastructure />} />
        <Route path="Education/:source" element={<Education />} />
        <Route path="Energy/:source" element={<Energy />} />
        <Route path="YouthEmpowerment/:source" element={<YouthEmpowerment />} />
        <Route path="Population/:source" element={<Population />} />
        <Route path="Economy/:source" element={<Economy />} />
        <Route path="InfoPage" element={<InfoPage/>} />
        <Route path="FutureHorizon/:source" element={<FurtureHorizon />}/>
        <Route path="RegionalAndInternationalContext/:source" element={<RIContext />} />
        <Route path="MapsAndGazetteer/:source" element={<MapsAndGazetteer />} />
        {/* <Route path="Smartcities/:source" element={<Smartcities />} /> */}
        <Route path="*"  element={<PageNotFound />} />
        
      </Routes>
    </BrowserRouter>
  );
}
